import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import { TIMEOUT_STORE } from 'util/constants';

const exports = storeModuleFactory({
    name:            'backupsAssociatedMachines',
    endpoint:        endpoints.backupsAssociatedMachines.endpoint,
    timeout:         TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    parseParameters: params => ({
    })
});

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/backupsAssociatedMachines.js